export default {"src":"/_next/static/media/matterport-museum.e0df2f77.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};